import React from 'react';

interface IToggle {
    'data-testid'?: string;
    checked?: boolean;
    id: string;
    label?: React.ReactNode;
    onChange: (_: any) => void;
    value: string;
}

const Toogle = ({
    'data-testid': dataTestId,
    value,
    label,
    onChange,
    id,
    checked,
}: IToggle) => (
    <div className="eds-toggle">
        <input
            id={id}
            type="checkbox"
            className="eds-toggle__input eds-is-hidden-accessible"
            value={value}
            defaultChecked={checked}
            onChange={(e) => {
                onChange(e.target.checked);
            }}
            data-testid={dataTestId}
        />
        <label
            className="eds-toggle__label eds-toggle__label--align-left"
            htmlFor={id}
        >
            <span className="eds-label__content">
                <div className="eds-toggle__controls eds-align--center-vertical">
                    <div className="eds-toggle__slider" />
                    <div className="eds-toggle__delegate" />
                </div>
                {label ? (
                    <span className="eds-text-color--grey-800 eds-text-bm eds-l-pad-left-4">
                        {label}
                    </span>
                ) : undefined}
            </span>
        </label>
    </div>
);

export default Toogle;
